import axios from 'axios';

const axiosInstance = axios.create({
    baseURL: '/api/v1',
    withCredentials: false,
});

axiosInstance.interceptors.response.use(
    res => {
        return res;
    },
    error => {
        return Promise.reject(error.response)
    }
);

export default axiosInstance;